import Head from "next/head";
import { Box, Button } from "@mui/material";
import { AuthGuard } from "../../components/authentication/auth-guard";
import { DashboardLayout } from "../../components/dashboard/dashboard-layout";
import { useAuth } from "../../hooks/use-auth";
import { DashboardContainerAgente } from "../../components/dashboard/dashboard-containers/dashboard-container-agente";
import { DashboardContainerDistribuidora } from "../../components/dashboard/dashboard-containers/dashboard-container-distribuidora";
import { DashboardContainerAdministrador } from "../../components/dashboard/dashboard-containers/dashboard-container-administrador";
import { DashboardContainerCallcenter } from "../../components/dashboard/dashboard-containers/dashboard-container-callcenter";

const Overview = () => {
  // Get current user using firebase auth
  const { user } = useAuth();

  return (
    <>
      <Head>
        <title>ELAM</title>
      </Head>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 8,
        }}
      >
        {user?.role === "agente" && <DashboardContainerAgente />}
        {user?.role === "distribuidora" && <DashboardContainerDistribuidora />}
        {user?.role === "administrador" && <DashboardContainerAdministrador />}

        {user?.role === "callcenter" && <DashboardContainerCallcenter />}
        {user?.role === "callcenteradmin" && <DashboardContainerCallcenter />}
      </Box>
    </>
  );
};

Overview.getLayout = (page) => (
  <AuthGuard>
    <DashboardLayout>{page}</DashboardLayout>
  </AuthGuard>
);

export default Overview;
